import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import {PROJECT_DETAILS} from "../projectCongifuration/type";

export const createProjectConfig = (requestData) => async (dispatch) => {
    const res = await callWebService(
      callTypes.post,
      requestData,
      Config.installation.createProjectConfig
    );
    if (res?.data?.response?.status === true) {
      return true;
    }
  };

export const getProjectConfig = (siteId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.getProjectConfig}?site_id=${siteId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: PROJECT_DETAILS, payload: data.response.data });
    return data.response.data;
  }
};